import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Loader } from '@calendly/ui/components/loader'
import { Popup, Header, Title, Body, Footer } from '@calendly/ui/components/popup'
import { BodyText } from '@calendly/ui/components/typography'

import { useDestroyTrackedMeetingMutation, useFetchTrackedMeetingWithSummaryQuery } from 'hooks/tracked_meetings/api/index'

export const DeleteRecapsModal = ({ isOpen, meetingUuids, onClose, onSuccess }) => {
  // Preserve optimistic update behavior for single UUID callers
  const singleUuid = meetingUuids.length === 1 ? meetingUuids[0] : null
  const { data, isLoading } = useFetchTrackedMeetingWithSummaryQuery({ meetingUuid: singleUuid }, { skip: !isOpen || !singleUuid })
  const [destroy] = useDestroyTrackedMeetingMutation()

  const onDelete = async () => {
    try {
      await Promise.all(
        meetingUuids.map((meetingUuid) => {
          const foreignEventId = singleUuid === meetingUuid ? data?.foreignEventId : undefined
          return destroy({ meetingUuid, foreignEventId }).unwrap()
        })
      )
      onSuccess?.()
      onClose()
    } catch (error) {
      console.error('Error deleting recaps:', error)
      onClose()
    }
  }

  if (!isOpen) return null

  if (isLoading && singleUuid) {
    return <Loader />
  }

  return (
    <Popup onClose={onClose}>
      <Header>
        <Title>
          {I18n.t('publisher.meeting_intelligence.details.delete_recap_modal.heading')}
        </Title>
      </Header>
      <Body>
        <BodyText>
          {singleUuid
            ? HtmlParser(I18n.t('publisher.meeting_intelligence.details.delete_recap_modal.text'))
            : HtmlParser(I18n.t('publisher.meeting_intelligence.details.delete_recap_modal.text_plural'))}
        </BodyText>
        <BodyText>
          {singleUuid
            ? HtmlParser(I18n.t('publisher.meeting_intelligence.details.delete_recap_modal.note'))
            : HtmlParser(I18n.t('publisher.meeting_intelligence.details.delete_recap_modal.note_plural'))}
        </BodyText>
      </Body>
      <Footer>
        <Button decoration="secondary-outline" wide onClick={onClose}>
          {I18n.t('publisher.action.nevermind')}
        </Button>
        <Button
          decoration="danger"
          wide
          onClick={(event) => {
            event.preventDefault()
            event.stopPropagation()
            onDelete()
          }}
        >
          {singleUuid
            ? I18n.t('publisher.meeting_intelligence.details.delete_recap_modal.delete_button_single')
            : I18n.t('publisher.meeting_intelligence.details.delete_recap_modal.delete_button_multiple', { count: meetingUuids.length })}
        </Button>
      </Footer>
    </Popup>
  )
}
